/** Base path when mounted under main App.js; empty when `start:nyafaz-engagement` owns `/`. */
export const NYAFAZ_ENGAGEMENT_BASE =
  process.env.REACT_APP_TARGET === 'nyafaz-engagement' ? '' : '/nyafaz-ep/nyafaz-engagement';

export function nyafazEngagementPath(subpath = '') {
  const tail = String(subpath || '').replace(/^\/+/, '');
  if (!NYAFAZ_ENGAGEMENT_BASE) {
    return tail ? `/${tail}` : '/';
  }
  const base = NYAFAZ_ENGAGEMENT_BASE.replace(/\/+$/, '');
  return tail ? `${base}/${tail}` : base;
}

export function nyafazEngagementFirstSegment(splat) {
  const trimmed = String(splat || '').replace(/^\/+|\/+$/g, '');
  if (!trimmed) return '';
  return trimmed.split('/')[0];
}
